module.exports = __webpack_public_path__ + "static/4-ad6de45186ffa5250fe44b88797398a8.jpg";